module.exports = __webpack_public_path__ + "static/ellipse-11-f04cedfb20addc8d72037fbc49be16c4.svg";